export const Appoiment  = [
   {
   id :1,
   img:'default/01.png',
   title:'Ossim keter',
   time:'1 Hour',
   date:'16 August',
   buttonName:'Pending',
   color:"primary",
   StatusClass: "active-online"
},
{
   id :2,
   img:'default/02.png',
   title:'Venter loren',
   time:'Now',
   date:'21 September',
   buttonName:'Done',
   color:"secondary",
   checkbox:"fa fa-check-circle",
   StatusClass: "active-busy"
},
{
   id :3,
   img:'default/03.png',
   title:'Fran loain',
   time:'2 Day After',
   date:'06 March',
   buttonName:'Pending',
   color:"success",
   StatusClass: "active-offline"
},
{
   id :4,
   img:'default/04.png',
   title:'Loften Horen',
   time:'Day End',
   date:'12 February',
   buttonName:'Pending',
   color:"info",
   StatusClass: "active-online"
},
{
   id :5,
   img:'default/05.png',
   title:'Loie fenter',
   time:'2 Day After',
   date:'06 March',
   buttonName:'Pending',
   color:"danger",
   StatusClass: "active-offline"
},

]